import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Workaround: DataGridComponent.ngOnDestroy in the design system calls removeChild
// on a node that Angular has already detached during route teardown. Guard against it.
const _removeChild = Node.prototype.removeChild;
Node.prototype.removeChild = function <T extends Node>(child: T): T {
  if (child.parentNode === this) {
    return _removeChild.call(this, child) as T;
  }
  return child;
};

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
